// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__K79P5","actions":"style_actions__-UvsN","actions_btn":"style_actions_btn__GoQ31"};